import axios from "axios";
import Qs from "qs";
import { BRAND } from "./hmcConfig";
import { settings } from "./settings";
import { printThankYouPage } from "./registrationForm";
import { log } from "./logger";
import { prefillFormAndSaveAnswers } from "./registrationForm";
import { ls } from "./localStorage";

export let formData = {};

export const gigyaSaveAnswers = async (account) => {
  if (!account || !account.UID) {
    log('No account for saving answers.');

    return;
  }

  const hmc = getAnswers();

  if (!hmc) {
    log('No answers to save.');

    return;
  }

  log('Saving answers...');

  const params = {
    UID: account.UID,
    profile: {
      firstName: account.profile.name,
      lastName: account.profile.surname,
      email: account.profile.email,
      locale: DLG.gigya.language,
    },
    data: {
      hmc,
    }
  };

  await gigya.accounts.setAccountInfo(params);

  log('Answers saved!');
}

function gigyaSetAccountInfo(res) {
  const params = {
    profile: {
      firstName: formData.name,
      lastName: formData.surname,
      email: formData.email,
      locale: DLG.gigya.language,
    }
  };

  if (res.hasOwnProperty("regToken")) {
    params['regToken'] = res.regToken;
  } else {
    params['UID'] = res.UID;
  }

  const hmc = getAnswers();

  if (hmc) {
    log('Saving answers within lite registration...');

    params['data'] = {
      hmc
    };
  }

  gigya.accounts.setAccountInfo(params, {
    callback: async function () {
      try {
        const isChecked = document.getElementById(
          "hmc-gigya-form-privacy"
        ).checked;
        const lang = gigya.thisScript.lang.originalLang;
        const countryCode = gigya.thisScript.globalConf.countryCodeMapping[lang];
        const siteConsent = gigya.thisScript.globalConf.consentMapping[countryCode];
        const axiosBaseInstance = axios.create({
          baseURL: window.DLG.config.encodedContextPath,
          timeout: 60 * 1000,
          headers: {
            CSRFToken: window.DLG.config.CSRFToken,
            "X-Requested-With": "XMLHttpRequest",
          },
          transformRequest(data) {
            return Qs.stringify(data, { arrayFormat: "repeat" });
          },
        });

        await new Promise((resolve, reject) => {
          axiosBaseInstance
            .post('/gigyaraas/lite-registration-info', {
              gigyaUID: res.UID || null,
              lang,
              countryCode,
              siteConsent,
              isChecked,
              campaignTag: `${settings.brand == BRAND.kenwood ? 'HMC-' : 'HMCDL-'}` + formData.productTag,
              origin: 'ECOMMERCE',
              email: formData.email,
              smsConsent: false,
            })
            .then((response) => resolve(function (response) {}))
            .catch((error) => reject(function (error) {}));
        });
      } catch(e) {
        log('/lite-registration-info error', e);
      }

      printThankYouPage();
      ls.set(ls.getKeyLeadForm(), true);
    },
  });
}

export const gigyaFormSend = async (fData) => {
  formData = fData;
  if (DLG.config.isLogged) {
    gigya.accounts.getAccountInfo({
      include: "preferences,profile",
      callback: (res) => gigyaSetAccountInfo(res),
    });
  } else {
    gigya.accounts.initRegistration({
      isLite: true,
      callback: (res) => gigyaSetAccountInfo(res),
    })
  }
};

export const gigyaGetAccountInfo = async () => {
  log("gigyaGetAccountInfo", false, true);
  if (ls.get(ls.getKeyLeadForm()) === true || forcePrintThankYou()) {
    printThankYouPage();
    return;
  }
  if (!DLG.config.isLogged) {
    log("user not logged", false, true);
    return;
  }
  log("user is logged", false, true);
  await gigya.accounts.getAccountInfo({
    include: "preferences,profile",
    callback: (res) => prefillFormAndSaveAnswers(res),
  });
};

const forcePrintThankYou = () => {
  let result = false;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Array.from(urlSearchParams.entries());
  params.forEach((param) => {
    if (param[0] == "thankYou") result = true;
  });
  return result;
};

const getAnswers = () => {
  if (!settings.answers || settings.answers.length === 0) {
    log('No answers.');
    return null;
  }

  const hmc = {};

  hmc[settings.brand] = {
    date: new Date().toISOString().split('T')[0],
    skus: settings.configuratorProducts || [] // .join(',') || ''
  }

  settings.answers.forEach((a, i) => {
    hmc[settings.brand]['answer' + (i + 1)] = a; // ?.join(',') || ''
  })

  return hmc;
}
